module.exports = "pegasus/assets/presentation-2-card.png";